import { Fragment, PropsWithChildren, useContext } from 'react'
import clsx from 'clsx'

import { getPanelRadioID } from './Wizard.helpers'
import WizardContext from './WizardContext'

import './Wizard.css'

export interface WizardStepProps {
  id: number | string
  className?: string
}

function WizardStep({ children, className, id }: PropsWithChildren<WizardStepProps>) {
  const wizardID = useContext(WizardContext)

  return (
    <>
      <input
        type="radio"
        className="visually-hidden"
        id={getPanelRadioID(id)}
        name={String(wizardID)}
        value={id}
        data-testid="panel-radio"
        tabIndex={-1}
      />
      <article
        id={String(id)}
        className={clsx('rg-wizard-step', className)}
        data-testid="wizard-step"
      >
        {children}
      </article>
    </>
  )
}

export default WizardStep
